import { z } from 'zod';
import { useUnleashVariant } from 'react-scale/hooks/useUnleashFeatureFlag';

export const FetchSmeStatus = (userId: string): boolean => {
  const smeWorkerSchema = z.array(z.string());
  const smeWorkerVariant = useUnleashVariant(
    'sme-worker-id',
    { userId },
    { name: 'sme-worker-id', enabled: false },
  );
  const smeWorkerIdsText: string = smeWorkerVariant?.payload?.value
    ? smeWorkerVariant?.payload?.value
    : ('' as string);
  if (smeWorkerIdsText) {
    try {
      const smeWorkerIds = smeWorkerSchema.parse(JSON.parse(smeWorkerIdsText));
      return smeWorkerIds.includes(userId);
    } catch (e) {
      return false;
    }
  }
  return false;
};
